import CourseController from '../../../../../components/diagrams/course.controller';

class DeductionToInductionPointsController extends CourseController {

  constructor(courseService, helperService, $sce, $window, $scope, $compile) {
    "ngInject";
    super(courseService, helperService, $sce, $scope);
    Object.assign(this, { helperService, $sce, $window, $scope, $compile });
    this.isUnit = true
    this.exerciseIdsStart = 'diagram3b4-'
    this.videoUrl = this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322764369');
    this.exerciseUserAnswers = {}
    // this.helperService.initIntercom();

    this.highlightWords = {
      ex1: false,
      ex2: false,
      ex3: false,
      ex4: false,
      ex5: false
    }

    setTimeout(() => {
      const offsetFromTop = {
        ex1: this.getOffsetFromTop('js-ex1'),
        ex2: this.getOffsetFromTop('js-ex2'),
        ex3: this.getOffsetFromTop('js-ex3'),
        ex4: this.getOffsetFromTop('js-ex4'),
        ex5: this.getOffsetFromTop('js-ex5')
      }

      for (const key in offsetFromTop) {
        const exerciseDescription = angular.element(`.js-${key}`);

        this.$compile(exerciseDescription)(this.$scope);
      }

      const halfOfUserWindowHeight = this.$window.innerHeight / 2;

      this.$window.onscroll = () => {
        const pagePosition = this.$window.scrollY + halfOfUserWindowHeight;

        for (const key in offsetFromTop) {
          if (!this.highlightWords[key] && pagePosition >= offsetFromTop[key]) {
            this.highlightWords[key] = true
          }
        }

        this.$scope.$apply();
      }
    }, 300);
  }

  getOffsetFromTop(elementClass) {
    const element = document.querySelector(`.${elementClass}`);

    return $(element).offset().top;
  }
}

export default DeductionToInductionPointsController;



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3b4/deductionToInduction/deductionToInduction.controller.js